import { render } from "./user-change-password-popup.vue?vue&type=template&id=5638b6fa&scoped=true"
import script from "./user-change-password-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./user-change-password-popup.vue?vue&type=script&setup=true&lang=js"

import "./user-change-password-popup.vue?vue&type=style&index=0&id=5638b6fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5638b6fa"],['__file',"src/views/administration/users/user-change-password-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5638b6fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5638b6fa', __exports__)) {
    api.reload('5638b6fa', __exports__)
  }
  
  module.hot.accept("./user-change-password-popup.vue?vue&type=template&id=5638b6fa&scoped=true", () => {
    api.rerender('5638b6fa', render)
  })

}


export default __exports__